import { createAction } from 'redux-actions';

export const ResendMailRequested = createAction('RESEND_MAIL_REQUESTED');
export const ResendMailRequestedReceived = createAction('RESEND_MAIL_REQUESTED_RECEIVED');
export const ResendMailRequestedReceivedFailure = createAction('RESEND_MAIL_REQUESTED_RECEIVED_FAILURE');
export const ClearResendMailData = createAction('CLEAR_RESEND_MAI_DATA');
